import audit from './en-US/audit';
import auditOverview from './en-US/audit-overview';
import bankConfig from './en-US/bank-config';
import budgetRequest from './en-US/budget-request';
import building from './en-US/building';
import component from './en-US/component';
import dailyReport from './en-US/daily-report';
import decoration from './en-US/decoration';
import electricFee from './en-US/electric-fee';
import entryRegistration from './en-US/entry-registration';
import error from './en-US/error';
import finance from './en-US/finance';
import financeReconciliation from './en-US/finance-reconciliation';
import globalHeader from './en-US/globalHeader';
import guest from './en-US/guest';
import handleHall from './en-US/hall-rental';
import house from './en-US/house';
import housekeeper from './en-US/housekeeper';
import houseUser from './en-US/houseUser';
import importNotice from './en-US/import-notice';
import menu from './en-US/menu';
import moveOut from './en-US/moveout';
import netFee from './en-US/net-fee';
import serviceOpen from './en-US/open-service';
import orderNo from './en-US/order-no';
import otherFee from './en-US/other-fee';
import pages from './en-US/pages';
import parking from './en-US/parking';
import parkingFee from './en-US/parking-fee';
import parkingManagementFee from './en-US/parking-management-fee';
import pay from './en-US/pay';
import propertyAgent from './en-US/property-agent';
import propertyFee from './en-US/property-fee';
import propertyOverview from './en-US/property-overview';
import pwa from './en-US/pwa';
import rental from './en-US/rental';
import repair from './en-US/repair';
import salesAgent from './en-US/sales-agent';
import salesOverview from './en-US/sales-overview';
import serviceConfig from './en-US/service-config';
import settingDrawer from './en-US/settingDrawer';
import settings from './en-US/settings';
import sys from './en-US/sys';
import waterFee from './en-US/water-fee';

export default {
  'navBar.lang': 'Languages',
  'layout.user.link.help': 'Help',
  'layout.user.link.privacy': 'Privacy',
  'layout.user.link.terms': 'Terms',
  'app.preview.down.block': 'Download this page to your local project',
  'app.welcome.link.fetch-blocks': 'Get all block',
  'app.welcome.link.block-list':
    'Quickly build standard, pages based on `block` development',
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...pages,
  ...audit,
  ...auditOverview,
  ...pay,
  ...finance,
  ...budgetRequest,
  ...serviceConfig,
  ...serviceOpen,
  ...handleHall,
  ...parkingFee,
  ...parkingManagementFee,
  ...propertyFee,
  ...waterFee,
  ...electricFee,
  ...netFee,
  ...otherFee,
  ...parking,
  ...house,
  ...building,
  ...houseUser,
  ...housekeeper,
  ...guest,
  ...decoration,
  ...moveOut,
  ...entryRegistration,
  ...error,
  ...salesOverview,
  ...propertyAgent,
  ...salesAgent,
  ...financeReconciliation,
  ...sys,
  ...repair,
  ...dailyReport,
  ...importNotice,
  ...orderNo,
  ...bankConfig,
  ...propertyOverview,
  ...rental,
};
